module.exports = __webpack_public_path__ + "img/pending-policies-icon-1.a1fd30b3.svg";